import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storageChange$ = new Subject<{ key: string; value: string | null }>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getItem(key: string): string | null {
    if (!this.isBrowser) return null;
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    if (!this.isBrowser) return;
    localStorage.setItem(key, value);
    this.storageChange$.next({ key, value });
  }

  removeItem(key: string): void {
    if (!this.isBrowser) return;
    localStorage.removeItem(key);
    this.storageChange$.next({ key, value: null });
  }

  clear(): void {
    if (!this.isBrowser) return;
    localStorage.clear();
    this.storageChange$.next({ key: '__all__', value: null });
  }

  watchKey(targetKey: string): Observable<string | null> {
    return this.storageChange$.pipe(
      filter(({ key }) => key === targetKey || key === '__all__'),
      map(({ key, value }) => (key === '__all__' ? null : value))
    );
  }
}
